export default __webpack_public_path__ + "static/2019_11-b9e2bc0faca57dc56a7e137da85b3eec.png";